import gql from 'graphql-tag';

export const UPSERT_SIGNUP_INFO_M = gql`
  mutation UpsertSignupInfoMutation (
    $userId: UUID!
    $phone: String!
    $roleId: Float!
    $otherRole: String
    $industryId: Float!
    $otherIndustry: String
    $companySizeId: Float
    $actualCompanySize: Float
    $regionId: Float!
    $subRegionId: Float
    $fromId: Float
    $otherFrom: String
    $hasSkip: Boolean
  ) {
    upsertSignupInfo(
      upsertSignupInfoDTO: {
        userId: $userId
        phone: $phone
        roleId: $roleId
        otherRole: $otherRole
        industryId: $industryId
        otherIndustry: $otherIndustry
        companySizeId: $companySizeId
        actualCompanySize: $actualCompanySize
        regionId: $regionId
        subRegionId: $subRegionId
        fromId: $fromId
        otherFrom: $otherFrom
        hasSkip: $hasSkip
      }
    ) {
      code
      success
      message
    }
  }
`;

export const ADD_USER_TO_PROVIDER_ORGANIZATION_M = gql`
  mutation AddUserToProviderOrganizationMutation (
    $organization: String!
    $mutationAddUserToProviderOrganizationUserInfoDTO: MutationAddUserToProviderOrganizationUserInfoDTO!
  ) {
    addUserToProviderOrganization(
      organization: $organization
      mutationAddUserToProviderOrganizationUserInfoDTO: $mutationAddUserToProviderOrganizationUserInfoDTO
    ) {
      code
      success
      message
    }
  }
`;

export const REMOVE_USER_FROM_PROVIDER_ORGANIZATION_M = gql`
  mutation RemoveUserFromProviderOrganizationMutation (
    $email: String!
    $organization: String!
  ) {
    removeUserFromProviderOrganization(
      email: $email
      organization: $organization
    ) {
      code
      success
      message
    }
  }
`;